const axios = require('axios')
import util from '../util/asymmetric'

const url = process.env.VUE_APP_API_URL

const state = {
  shopLineOA: [],
  subsetsShop: `${localStorage.getItem('shopLineObjectId')}`,
}

const mutations = {
  GET_SHOP_LINE_OA(statement, shopLineOA) {
    statement.shopLineOA = shopLineOA
  },
  SET_SHOP_LINE_OA(statement, subset) {
    statement.subsetsShop = subset
  },
}

const actions = {
  getShopLineOA({ commit }) {
    let urlParams = new URLSearchParams(window.location.search) || null
    let uid = localStorage.getItem('uid') || urlParams.get('uid')

    let token = util.asymmetric()

    if (uid != null) {
      axios({
        method: 'get',
        url: url + '/api/v1.0/' + uid + '/Shop/uidwithkey',
        headers: {
          token: token,
          // 'ngrok-skip-browser-warning': 'true',
        },
      })
        .then((res) => {

          const shopLineOA = res.data.data;
      
          if (Array.isArray(shopLineOA) && shopLineOA.length > 0) {
            const shopObjectId = shopLineOA[0].objectId;
            localStorage.setItem('shopLineObjectId', shopObjectId);
      
            if (state.subsetsShop === 'null' || !state.subsetsShop) {
              state.subsetsShop = shopObjectId;
            }
      
            commit('GET_SHOP_LINE_OA', shopLineOA);
          } else {
            console.warn('⚠️ No shop data received from API');
            // แนะนำ: ตั้งค่า default หรือ redirect กลับ home
          }
        })
        .catch((error) => {
          console.error(error)
        })
    }
  },
  setShopLineOA(context, subset) {
    context.commit('SET_SHOP_LINE_OA', subset)
  },
}

const getters = {
  shopLineOA: (statement) => statement.shopLineOA,
  shopLineObjectId: (statement) => statement.subsetsShop,
}

export default {
  state,
  actions,
  mutations,
  getters,
}
